export enum PerimeterType {
    STORE = 'store', REGION = 'region', COUNTRY = 'country'
}
